import React, { FC, Ref, useEffect, useRef, useState } from 'react';
import { MdSearch } from 'react-icons/md';
import styled from 'styled-components';
import { LabelValidator } from './label-validador';
import { InputProps } from './props';
import { StyledInput, StyledLabel, Container } from './styles';

const CustomInput = styled(StyledInput)`
    padding: 17px 28px 1px 10px;
`;

const CustomLabel = styled(StyledLabel)`
    padding-right: 25px;
`;

const SearchIcon = styled(MdSearch)<{ onClick: Function | undefined }>`
    position: absolute;
    right: 6px;
    top: 13px;
    font-size: 22px;
    color: #666;

    ${props => !!props.onClick && `
        cursor: pointer;
    `}
`;

export const InputSearch: FC<InputProps> = ({
    label,
    color = '#47516f',
    isValid,
    style,
    value,
    onChange,
    onClick,
    ...rest
}) => {
    const ref: Ref<HTMLInputElement> = useRef(null);
    const [text, setText] = useState(value || '');
    const [focused, setFocused] = useState(false);

    useEffect(() => {
        if (ref.current) {
            ref.current.onfocus = () => setFocused(true);
            ref.current.onblur = () => setFocused(false);
        }
    }, [ref]);

    useEffect(() => {
        setText(value || '');
    }, [value]);

    return (
        <Container style={style}>
            <CustomInput
                {...rest}
                isValid={isValid}
                type='text'
                value={text}
                ref={ref}
                onChange={(ev: any) => {
                    setText(ev.target.value);
                    return onChange?.(ev);
                }}
                placeholder=''
            />
            <SearchIcon title={rest.title} onClick={onClick} />
            <CustomLabel active={focused || text !== ''}>{label}</CustomLabel>
            <LabelValidator isValid={isValid} />
        </Container>
    );
};
